import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { Button, Input, Modal } from '../../../components'
import { modalClose } from '../../../layout/redux/layoutActions'
import { calculadoraCompraDeAtivos, CheckoutAtivosAvulsosXD, listarAtivos } from '../redux/minhasAssinaturasActions'

import { PopoverCentralAjuda } from '../../../components/popovercentralajuda/popovercentralajuda'


export default () => {
  const dispatch = useDispatch()
  const { sistema, device, usuario, statusModal } = useSelector(state => state.layoutState)
  const { ativos, avaliacoes, assinatura } = useSelector(state=> state.minhasAssinaturasState)
  const nls = require(`../nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../../layout/nlsPopup/${sistema.idioma}.json`)
  const [form, setForm] = useState({avaliacoes: []})

  const nlsContexto = require(`../../centralAjuda/nlscontexto/${sistema.idioma}.json`)

  const idarray = [112];


  useEffect(()=> {
    console.error('assinaturas-adquirir-avaliacoes', avaliacoes);
    if (statusModal === 'assinaturas-adquirir-avaliacoes') {
      
      dispatch(listarAtivos({consumoConta: sistema.consumoConta, moeda: usuario.moedaIso4217, tipo: 'SCE', status: 'vazio', idioma: sistema.idiomaIdValue}))
      const hasChange = form.avaliacoes.find(a=> a.id === 6)
      const params = [
          {
            id: 6,
            descricao: nls.avaliacoesMensaisAdicionais,
            quantidadeDesejada: hasChange.id ? hasChange.quantidadeDesejada : 100,
            valor: 0,
          }
      ]
      if (!hasChange.id) {
        setForm({...form, avaliacoes: params})
      }
      console.error(params, 'assinaturas-adquirir-avaliacoes params');
      dispatch(calculadoraCompraDeAtivos({ativos: params, moeda: usuario.moedaIso4217}))
    }
  }, [statusModal, sistema.idioma, sistema.consumoConta])
  
  useEffect(()=> {
    const listaAtivos = [
      {
        id: 6,
        descricao: nls.avaliacoesMensaisAdicionais,
        valor: 0,
        quantidadeDesejada: '100'
      }
    ]
    setForm({...form, avaliacoes: listaAtivos})
  }, [])
 
  const handleChange = e => {
    const params = [
        {
          id: 6,
          descricao: nls.avaliacoesMensaisAdicionais,
          quantidadeDesejada: e.quantidadeDesejada,
          valor: 0,
        }
    ]
    setForm({...form, avaliacoes: params})
    dispatch(calculadoraCompraDeAtivos({ativos: params, moeda: usuario.moedaIso4217}))
  }

  const handleCancelar = e => {
    dispatch(modalClose())
  }
  
  const handleSalvar = e => {
    const hasAtivos = form.avaliacoes?.filter(a=> a.quantidadeDesejada > 0)
    if (hasAtivos.length) {
      const params = {
        moeda: usuario.moedaIso4217,
        ativos: [...ativos, 
          ...form.avaliacoes
        ]
  
      }
      dispatch(CheckoutAtivosAvulsosXD(params, nlsPopup))
    }
  }
  
  
  return (
    <Modal
      name='assinaturas-adquirir-avaliacoes'
      title={
        <span style={{ display: 'inline', whiteSpace: device !== 'desktop' ? 'normal' : 'nowrap' }}>
          {nls[false ? 'titleAlterarAvaliacoes' : 'titleAdquirirAvaliacoes']}{' '}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray} />
        </span>
      }
      open={statusModal === 'assinaturas-adquirir-avaliacoes' ? true : false}
      close={() => handleCancelar()}
      closeText={nls.btnFechar}

      

      actions={<>
        <Button
          color='default'
          onClick={()=> handleCancelar()}
        >{nls.cancelar}</Button>
        <Button
          color='primary'
          onClick={()=> handleSalvar({})}
        >{nls[false? 'editarAvaliacoes' : 'salvarAvaliacoes']}</Button>
      </>}

    >
      <div>
        <div className='avaliacoes-lista'>
          {form.avaliacoes?.map(e=> {
            const min = 100
            const max = 100000
            return <div key={e.id} className='avaliacoes-lista-item'>
              <div className='avaliacoes-lista-item-info'>
                <strong>{e.descricao}</strong>
                {/* <small>{nls[e.id === 'avaliacoes-mensais-adicionais' ? 'avaliacoesAtuais' : 'valorAtual']}: {e.valor}</small> */}
              </div>
              <div className='avaliacoes-lista-item-input'>
                  <Input 
                    type='number'
                    value={e.quantidadeDesejada}
                    action={a=> handleChange({...e, quantidadeDesejada: a.value})}
                    min={min}
                    max={max}
                    step="100"
                  />
              </div>
            </div>
          })}
        </div>
        <div className='avaliacoes-info'>
          <span>{nls.valorCobradoImediatamente}: <strong>{avaliacoes.valorAdicional}</strong> </span>
          {!(assinatura.statusId === 'SAA' || assinatura.statusId === 'SAC') ? 
            <span>{nls.valorCobradoProxima}: <strong>{avaliacoes.valorTotal}</strong> </span>
          :null}
        </div>
      </div>
    </Modal>
  )
}
